// Legacy types file - now re-exports from organized structure
// This file is kept for backward compatibility

export * from './types/index';

// `DepthChartEntry`, `FormationPosition`, `Formation` and `SportFormations` used to be
// redeclared here as "additional legacy types" — but a local `export interface` shadows
// the same name coming from the `export *` above, so four call sites that imported
// `DepthChartEntry` from here (rather than from `./types/depth-chart` directly) were
// silently getting a STALE copy missing `formation`, `is_template`, `order_index` and
// `position_full_name` (sc-276 D6). Removed so every importer gets the one real
// definition from `types/depth-chart.ts` via the re-export above.

// Sport formats configuration
export const SportFormats: Record<string, string[]> = {
  Football: ['5v5', '6v6', '7v7', '8v8', '9v9', '11v11'],
  FlagFootball: ['4v4', '5v5', '6v6', '7v7', '8v8'],
  Basketball: ['1v1', '2v2', '3v3', '4v4', '5v5'],
  Baseball: ['9v9'],
  Softball: ['10v10', '9v9'],
  Soccer: ['3v3', '4v4', '5v5', '6v6', '7v7', '9v9', '11v11'],
  Volleyball: ['2v2', '3v3', '4v4', '6v6'],
  Hockey: ['3v3', '4v4', '5v5', '6v6'],
  Lacrosse: ['3v3', '4v4', '6v6', '7v7', '10v10', '12v12'],
  Tennis: ['Singles', 'Doubles', 'Mixed Doubles'],
};